import React, {Component} from 'react';
import marketStyle from '../css/markets.css';
import OddsCard from './oddsCard';
import { getText } from '../../../../../helpers/localization';

class FourOddsMarket extends Component {
    render() {
        let store = this.props.store;
        let markets = this.props.markets;
        return (<div className={marketStyle.marketGroup}>
            <div className={marketStyle.scoreGroup}>
                <OddsCard store={store} market={markets[0]} homeTeam={this.props.awayTeam}
                          awayTeam={this.props.homeTeam} multiDisplay={false} underOver ={true} marketName={getText(markets[0].selection,store,[this.props.playerOne])}/>
                <OddsCard store={store} market={markets[2]} homeTeam={this.props.awayTeam}
                          awayTeam={this.props.homeTeam} multiDisplay={false} underOver ={true} marketName={getText(markets[2].selection,store,[this.props.playerTwo])}/>
                 <OddsCard store={store} market={markets[4]} homeTeam={this.props.awayTeam}
                          awayTeam={this.props.homeTeam} multiDisplay={false} underOver ={true} marketName={getText(markets[4].selection,store)}/>
            </div>
            <div className={marketStyle.scoreGroup}>
                <OddsCard store={store} market={markets[1]} homeTeam={this.props.awayTeam}
                          awayTeam={this.props.homeTeam} multiDisplay={false}  underOver ={true} marketName={getText(markets[1].selection,store,[this.props.playerOne])}/>
                <OddsCard store={store} market={markets[3]} homeTeam={this.props.awayTeam}
                          awayTeam={this.props.homeTeam} multiDisplay={false}  underOver ={true} marketName={getText(markets[3].selection,store,[this.props.playerTwo])}/>
                 <OddsCard store={store} market={markets[5]} homeTeam={this.props.awayTeam}
                          awayTeam={this.props.homeTeam} multiDisplay={false} underOver ={true} marketName={getText(markets[5].selection,store)}/>
            </div>
        </div>);
    }
}

export default FourOddsMarket;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/components/fourOddsMarket.js